import {useEffect, useState} from 'react';
import {Loading as AcudLoading} from 'acud';
import {LoadingProps as AcudLoadingProps} from 'acud/es/loading';

import styles from './index.less';

export interface LoadingProps extends AcudLoadingProps {
    className?: string;
    placement?: 'left' | 'middle' | 'right';
}

export default ({
    children,
    className,
    loading = true,
    placement = 'middle',
    ...restProps
}: LoadingProps) => {
    const [innerLoading, setInnerLoading] = useState(!!loading);
    const isLeaving = innerLoading && !loading;

    useEffect(
        () => {
            if (loading) {
                setInnerLoading(true);
                return;
            }

            if (!innerLoading) {
                return;
            }

            const timer = window.setTimeout(() => {
                setInnerLoading(false);
            }, 300);

            return () => {
                window.clearTimeout(timer);
            };
        },
        [innerLoading, loading]
    );

    return (
        <div className={styles('wrapper', {isLeaving}, `${placement}Placement`, className)}>
            <AcudLoading
                {...restProps}
                loading={innerLoading}
            >
                {children}
            </AcudLoading>
        </div>
    );
};
